import { Button, FormControl, Grid, Group, IconButton, Layout, Page } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { useFetch, useForm, useGrid, useModal, usePage, useResource, useStore, useToast, useAuth } from "@/comn/hooks";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
    APIS,
    URLS,
    SF_DOC_BOX_MGMT_SRCH,
    SG_DOC_BOX_MGMT_LIST,
} from "@/tra/tancis/ptli/elctdoc/chnl/services/PtliChnlMgmtService";

/*
 * Channel List Popup
 * !== 채널 목록 팝업 ==!
 */
export const PTLI0705004Q = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage({
        auth: ["auth_ptli0015", "auth_ptlianyADM", "auth_ptli0046", "auth_ptli0047"],
    });
    const { t } = useTranslation(); // Translation Hook !== 언어 변환 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal();
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const { callback, sndrcvDvnCd } = props;

    useResource({
        defaultSchema: [
            { area: "comnCd", comnCd: "COM0024" },
            { area: "comnCd", comnCd: "CGM0176" },
            { area: "comnCd", comnCd: "COM0069" }, // 대상 유형 코드
            { area: "comnCd", comnCd: "COM0080" }, // 채널 신청 진행상태 코드
            { area: "comnCd", comnCd: "COM0064" }, // 활성화 여부 코드
            { area: "comnCd", comnCd: "COM0077" }, // 송수신 유형 코드
        ],
    });

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        docBoxMgmtSrch: useForm({
            defaultSchema: SF_DOC_BOX_MGMT_SRCH,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    const grid = {
        docBoxMgmtList: useGrid({
            defaultSchema: SG_DOC_BOX_MGMT_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        // Get a list of channel. !== 채널 목록을 조회한다. ==!
        getElctDocBoxList: useFetch({
            api: (page = grid.docBoxMgmtList.page) => {
                return APIS.getElctDocBoxList(form.docBoxMgmtSrch.getValues(), page, grid.docBoxMgmtList.size);
            },
            enabled: !comnUtils.isEmpty(sndrcvDvnCd),
            key: [grid.docBoxMgmtList.page, grid.docBoxMgmtList.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.docBoxMgmtSrch.getValues(),
                    page: grid.docBoxMgmtList.page,
                    size: grid.docBoxMgmtList.size,
                });
            },
            onError: () => toast.showToast({ type: "error", content: "msg.com.00025" }), // Failed to select. !== 조회가 실패하였습니다. ==!
            showToast: true,
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        // Click Search Button !== 검색버튼 ==!
        getElctDocChnlList: (page: number = 0) => {
            form.docBoxMgmtSrch.handleSubmit(
                () => {
                    form.docBoxMgmtSrch.setValue("chnlAplyPrcdStatCd", "C");
                    form.docBoxMgmtSrch.setValue("actvtYn", "Y");
                    form.docBoxMgmtSrch.setValue("sndrcvDvnCd", sndrcvDvnCd);

                    grid.docBoxMgmtList.setPage(page);
                    fetch.getElctDocBoxList.fetch(page);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },
        // Enter Keyword text !== 검색어 엔터 이벤트 ==!
        onEnterKwdTxt: () => {
            form.docBoxMgmtSrch.setValue("sndrcvDvnCd", sndrcvDvnCd);
            grid.docBoxMgmtList.setPage(0);
            fetch.getElctDocBoxList.fetch(0);
        },
        onApplyBtnClick: (cell: any) => {
            if (!grid.docBoxMgmtList.isChecked()) {
                modal.openModal({ content: "msg.ptl.00687" }); // 등록대상을 선택하세요.
                return;
            }

            callback(grid.docBoxMgmtList.getChecked());
        },
    };

    /*
     * Declaration Event Render
     * !== 랜더 정의 ==!
     */
    const render = {
        grid_chnlList: {
            cell: {
                chnlNm: (props: any) => {
                    const { value } = props;
                    return <a style={{ cursor: "pointer" }}>{value}</a>;
                },
            },
        },
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        form.docBoxMgmtSrch.setValue("sndrcvDvnCd", sndrcvDvnCd);
        grid.docBoxMgmtList.setOption("checkbox", true);
    }, []);

    const kwdSel = form.docBoxMgmtSrch.watch("kwdSel");

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.docBoxMgmtSrch.schema.bsopClsfCd}></Group.Control>
                            <Group.Control {...form.docBoxMgmtSrch.schema.inexTpCd}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.docBoxMgmtSrch.schema.actvtYn} defaultValue={"Y"}></Group.Control>

                            <Group.Label label={"L_KWD"} />
                            <Group.Col padding={1}>
                                <Layout direction="row" gap={1}>
                                    <FormControl {...form.docBoxMgmtSrch.schema.kwdSel} />
                                    <FormControl
                                        {...form.docBoxMgmtSrch.schema.kwdTxt}
                                        readOnly={!kwdSel}
                                        onEnter={handler.onEnterKwdTxt}
                                    />
                                </Layout>
                            </Group.Col>
                        </Group.Row>
                    </Group.Section>
                    <Layout direction="row">
                        <Layout.Left>
                            <Button role={"reset"} onClick={() => form.docBoxMgmtSrch.reset()} />
                        </Layout.Left>
                        <Layout.Right>
                            <Button
                                role="search"
                                onClick={() => {
                                    handler.getElctDocChnlList();
                                }}
                            ></Button>
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid {...grid.docBoxMgmtList.grid} data={fetch.getElctDocBoxList.data?.elctDocBoxList} />
                    </Group.Section>
                </Group.Body>
            </Group>

            <Layout>
                <Layout.Right>
                    <Layout.Button role={"apply"} onClick={handler.onApplyBtnClick} />
                </Layout.Right>
            </Layout>
        </Page>
    );
};
